import { exactagScope, exactagState } from "../core/utils.js";
import { exactagData } from "../core/data.js";
import type { ExactagSync } from "../sync.types.js";
import type { ExactagData } from "../core/core.types.js";

export const varnishData: ExactagSync["varnish"] = {
  data: [],
  version: "0.8.9",
};

/*    */
/*                                       */
/*  */
/*                                                      */
/*  */
/*       */
/*                                                                     */
/*                                                  */

const log = exactagScope.scope("collect.varnish");

/**
 *
 *
 *
 *
 *
 */
export function appendVarnishData(
  data = exactagData,
  varnish = varnishData
): ExactagData {
  if (exactagState.isFirstRun) {
    log.debug("Append varnish data to exactag data");
    Object.assign(data, ...varnish.data);
    exactagState.isFirstRun = false;
  }

  return data;
}
